import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChildren, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges } from '@angular/core';
import { TabComponent } from '../../shared/assertion/tab/tab.component';
import { Router } from '@angular/router';
import { RulevarService } from 'src/app/rule/rulevar.service';

@Component({
  selector: 'rule-tabs',
  templateUrl: './rule-tabs.component.html',
  styleUrls: ['./rule-tabs.component.scss']
})
export class RuleTabsComponent implements OnInit, AfterContentInit, OnChanges{

  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

  @Output()selectedIndexChange:EventEmitter<number>= new EventEmitter<number>();
  @Input() selectedIndex:number;
  @Input() tabclickChange:boolean = true;
  @Input() editState:boolean = false;
  @Input() ruleId:string = ''

  constructor(private router:Router,public rulevarservice: RulevarService) { }
  private currentIndex:number;

  ngOnInit(): void {
    this.currentIndex = this.selectedIndex
  }

  ngOnChanges(changes:SimpleChanges) {
    this.selectedIndexChanged(changes)
  }

  ngAfterContentInit(): void {
    let activeTabs = this.tabs.filter((tab)=>tab.active);
    if(activeTabs.length === 0 && !this.currentIndex) {
      this.tabs.first.active=true;
      this.currentIndex = 0
    }else{
      this.tabs.toArray()[this.currentIndex].active=true;
    }
  }

  closeTab(){
    this.tabs.toArray().forEach(tab => tab.active = false);
  }

  checkPresentTab(previousindex:number,index:number){
    return previousindex !== index
  }

  selectTab(tab: TabComponent,index:number){
    if(this.checkPresentTab(this.currentIndex,index) && this.tabclickChange){
      this.closeTab()
      this.activeTab(index)
    }
  }

  activeTab(index:number){
    this.tabs.toArray()[index].active=true;
    this.currentIndex = index
    this.selectedIndexChange.emit(index)
  }

  selectedIndexChanged(changes:any){
    if(!changes.selectedIndex?.firstChange && this.checkPreviousIndex()){
      this.currentIndex = this.selectedIndex;
      this.closeTab()
      this.activeTab(changes.selectedIndex.currentValue)
    }
  }
  checkPreviousIndex() {
    return this.selectedIndex != this.currentIndex
  
  }
  close(){
    if(this.rulevarservice.isIntel){
      this.rulevarservice.intelSelectedIndex=0
      // this.rulevarservice.closerule(2);
      // this.rulevarservice.selectedIndex=1
      // this.rulevarservice.ruleLandingchangeTab(1)
      this.router.navigateByUrl("intel-list");
    }else{
      this.rulevarservice.closerule(1);
    }
    
    this.rulevarservice.fields=[]
    this.rulevarservice.platformFields=[]
    this.rulevarservice.selectedFields=[]
  }

}
